import React, { useState } from "react";
import { Container, Grid, Stack } from "@mui/material";
import LoanForm from "../components/LoanForm";
import LoanList from "../components/LoanList";
import FinancePageHeader from "../components/finance/FinancePageHeader";
import DashboardLayout from "../components/Layout/DashboardLayout";
import { useAuth } from "../context/AuthContext";

const LoansPage = () => {
  const { user } = useAuth();
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <DashboardLayout
      role={user?.role}
      activePage="/loans"
      title="Gestion des prêts"
    >
      <Container maxWidth="xl" sx={{ mt: 3, mb: 4 }}>
        <Stack spacing={2.5}>
          <FinancePageHeader
            title="Gestion des prêts"
            subtitle="Créez les prêts accordés aux débiteurs et suivez les encours de remboursement."
          />

          <Grid container spacing={2}>
            <Grid item xs={12} lg={5}>
              <LoanForm onCreated={() => setRefreshKey((prev) => prev + 1)} />
            </Grid>

            <Grid item xs={12} lg={7}>
              <LoanList refreshKey={refreshKey} />
            </Grid>
          </Grid>
        </Stack>
      </Container>
    </DashboardLayout>
  );
};

export default LoansPage;